/**
 * Page Transitions
 */

var PageTransitions = (function($) {
  const STORAGE_KEY = "palmaProjectTransition";

  function isModifiedEvent(e) {
    return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
  }

  function createLayer() {
    let layer = document.querySelector(".page-transition-layer");

    if (!layer) {
      layer = document.createElement("div");
      layer.className = "page-transition-layer";
      layer.innerHTML = '<div class="page-transition-overlay"></div>';
      document.body.appendChild(layer);
    }

    return layer;
  }

  function getAbsoluteRect(el) {
    const rect = el.getBoundingClientRect();

    return {
      top: rect.top,
      left: rect.left,
      width: rect.width,
      height: rect.height,
      radius: window.getComputedStyle(el).borderRadius || "10px"
    };
  }

  function saveTransitionData(data) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }

  function getTransitionData() {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  }

  function clearTransitionData() {
    sessionStorage.removeItem(STORAGE_KEY);
  }

  /**
   * LIST PAGE
   */

  function initArchiveTransition() {
    const links = document.querySelectorAll(".work-item__link");

    if (!links.length) return;

    links.forEach(link => {
      link.addEventListener("click", e => {
        if (isModifiedEvent(e) || link.target === "_blank") return;

        const item = link.closest(".work-item");
        const wrapper = item.querySelector(".work-item__video-wrapper");
        const media = wrapper.querySelector("video, img");

        if (!wrapper || !media) return;

        e.preventDefault();

        const rect = getAbsoluteRect(wrapper);

        const poster =
          media.getAttribute("poster") ||
          media.querySelector("source")?.getAttribute("src") ||
          "";

        saveTransitionData({
          href: link.href,
          rect,
          poster
        });

        const layer = createLayer();
        const overlay = layer.querySelector(".page-transition-overlay");

        const clone = document.createElement("div");

        clone.className = "page-transition-thumb";
        clone.style.top = rect.top + "px";
        clone.style.left = rect.left + "px";
        clone.style.width = rect.width + "px";
        clone.style.height = rect.height + "px";
        clone.style.borderRadius = rect.radius;

        clone.innerHTML = `<img src="${poster}" />`;

        layer.appendChild(clone);

        wrapper.style.visibility = "hidden";

        requestAnimationFrame(() => {
          overlay.style.opacity = "1";

          clone.style.transition = "all .35s cubic-bezier(.22,1,.36,1)";
          clone.style.transform = "scale(1.04)";
        });

        setTimeout(() => {
          window.location.href = link.href;
        }, 260);
      });
    });
  }

  /**
   * SINGLE PAGE
   */

  function initSingleTransition() {
    const page = document.querySelector(".js-project-page");
    const target = document.querySelector(".js-project-transition-target");

    if (!page || !target) return;
    const data = getTransitionData();

    if (!data || data.href !== window.location.href) {
      page.classList.add("is-ready");
      return;
    }

    const layer = createLayer();
    const overlay = layer.querySelector(".page-transition-overlay");

    const targetRect = getAbsoluteRect(target);

    const clone = document.createElement("div");

    clone.className = "page-transition-thumb";

    clone.style.top = data.rect.top + "px";
    clone.style.left = data.rect.left + "px";
    clone.style.width = data.rect.width + "px";
    clone.style.height = data.rect.height + "px";

    clone.innerHTML = `<img src="${data.poster}" />`;

    layer.appendChild(clone);

    target.style.visibility = "hidden";

    requestAnimationFrame(() => {
      clone.style.transition = "all .7s cubic-bezier(.22,1,.36,1)";
      overlay.style.opacity = "0";

      clone.style.top = targetRect.top + "px";
      clone.style.left = targetRect.left + "px";
      clone.style.width = targetRect.width + "px";
      clone.style.height = targetRect.height + "px";
    });

    setTimeout(() => {
      target.style.visibility = "visible";
      page.classList.add("is-ready");

      clone.remove();
      clearTransitionData();
    }, 720);
  }

  function initPageTransitions() {
    initArchiveTransition();
    initSingleTransition();
  }

  function init() {
    if (!$(".main").length) return;

    initPageTransitions();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(PageTransitions.init);
